/* sucrase/dist/esm/util/getIdentifierNames.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.default = getIdentifierNames;
    const types_1 = require("f0c35cbd76") /* ../parser/tokenizer/types */;
    /**
     * Get all identifier names in the code, in order, including duplicates.
     */
    function getIdentifierNames(code, tokens) {
        const names = [];
        for (const token of tokens) {
            if (token.type === types_1.TokenType.name) {
                names.push(code.slice(token.start, token.end));
            }
        }
        return names;
    }
}
